// Account-level feature modules delivered in the profile response under `account_modules`.
// Kept separate from PERMISSIONS so module flags are never confused with user permissions.
export default {
  ADVANCED_SEARCH: 'advanced_search',
  NEW_UI_2026_06: 'new_ui_2026_06',
};
